module.exports = "<my-title my-label=\"$root.labels.account.changePassword\"\n  my-style=\"$root.styles.titles.center\"\n  my-level=\"3\">\n</my-title>\n\n<my-change-password-form>\n</my-change-password-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/account/templates/edit.html
// module id = 1474
// module chunks = 0